import { create } from "zustand";
import type { SessionUser } from "@titancloud/shared";

interface AuthState {
  user: SessionUser | null;
  isLoading: boolean;
  /** Atomic: sets user + clears loading in one update — avoids mid-render inconsistency */
  initAuth: (user: SessionUser | null) => void;
  setUser: (user: SessionUser | null) => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  initAuth: (user) => set({ user, isLoading: false }),
  setUser: (user) => set({ user }),
  setLoading: (isLoading) => set({ isLoading }),
}));
